import Vue from 'vue';
import api from "../../util/api";

export const CATEGORIES_SET = 'CATEGORIES_SET';
export const CATEGORIES_LOAD = 'CATEGORIES_LOAD';

export default {
    state: {
        map: {},
        list: [],
    },

    mutations: {
        [CATEGORIES_SET](state, list) {
            state.list = [];
            list.forEach(item => {
                state.list.push(item.id);
                Vue.set(state.map, item.id, item);
            })
        }
    },

    getters: {
        categories: state => state.list,
        categoryById: state => id => state.map[id],
    },

    actions: {
        async [CATEGORIES_LOAD]({commit}) {
            console.log('lol')
            const {data} = await api.categories();
            commit(CATEGORIES_SET, data.data);
        }
    }
}